import { useState, FC } from "react"
// import { popoutModel } from "shared/ui/popout-root"

import styles from './styles.module.scss'
import { admissionModel } from "..";
import { popoutModel } from "shared/ui/popout-root";
import { LegalFormDisclaimer } from "shared/ui/legal-form-disclaimer";
import { getNameError, getPhoneError } from "shared/lib/lead-form-validation";
import { useTimedVisibility } from "shared/hooks/use-timed-visibility";

// type TCourseAPI = {
//     name: string
//     phone: string
//     course: string
// }

const training = {
    online_1: 'Онлайн. Индивидуально',
    online_2: 'Онлайн. Закрытая группа',
    online_3: 'Онлайн. Группа',
    offline_1: 'Оффлайн. Индивидуально',
    offline_2: 'Оффлайн. Закрытая группа',
    offline_3: 'Оффлайн. Группа',
}

export const Admission: FC = () => {

    const [name, seteName] = useState({ val: '', edit: 0 });
    const [phone, setPhone] = useState({ val: '', edit: 0 });
    
    const [isSend, setIsSend] = useState(false)
    const [consentAccepted, setConsentAccepted] = useState(false)

    const course = admissionModel.selectors.useCourseSelect()
    const train_id = admissionModel.selectors.useTrainingSelect()
    const pricingSelect = admissionModel.selectors.usePricingSelect()

    const nameMsg = getNameError(name.val, name.edit !== 0)
    const phoneMsg = getPhoneError(phone.val, phone.edit !== 0)
    const canSubmit =
        getNameError(name.val, true) === null &&
        getPhoneError(phone.val, true) === null &&
        consentAccepted
    const toastKey =
        train_id && !isSend
            ? [nameMsg, phoneMsg].filter(Boolean).join(' · ') || null
            : null
    const showValidationToast = useTimedVisibility(toastKey, 2500)

    if(!train_id) return <></>

    // Извлекаем количество месяцев из строки duration
    const getMonthsFromDuration = (duration: string): number => {
        const match = duration.match(/(\d+)/);
        return match ? parseInt(match[0]) : 1;
    };

    const calculatePricingDetails = () => {
        const pricing = course?.pricingOption || (pricingSelect ? {
            format: pricingSelect.format,
            type: pricingSelect.type,
            price: pricingSelect.price
        } : null);

        if (!pricing || !course?.courseData) return null;

        const months = getMonthsFromDuration(course.courseData.duration);
        const totalMonthly = pricing.price * months;
        const discount = 10000;
        const totalUpfront = totalMonthly - discount;
        
        return {
            months,
            totalMonthly,
            discount,
            totalUpfront
        };
    };

    const pricingDetails = calculatePricingDetails();

    const onName = (e: React.ChangeEvent<HTMLInputElement>) => {
        let { value } = e.currentTarget;
        let v = value + '.';

        if (v.slice(-3, -1) === "  ") {
            value = value.slice(0, -1);
        }
        seteName({ val: value.slice(0, 13), edit: 1 });
    }

    const onPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
        let { value } = e.currentTarget;
        let v = value;

        if (v.length === 0) setPhone({ val: '+7', edit: 1 })
        else {
            setPhone({ val: value.slice(0, 20), edit: 1 });
        }
    }

    const sendForm = () => {
        if(isSend) {
            popoutModel.events.setPopout(null)
            return
        }

        if (!canSubmit) {
            return
        }

        fetch('https://itansar.ru/ansar/tg.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                name: name.val,
                phone: phone.val,
                course: course?.name || 'Не выбран',
                courseData: course?.courseData || null,
                pricingOption: course?.pricingOption || (pricingSelect ? {
                    format: pricingSelect.format,
                    type: pricingSelect.type,
                    price: pricingSelect.price
                } : null),
                // Оставляем для совместимости со старой системой
                train: train_id?.id || 0,
                pricing: pricingSelect ? {
                    format: pricingSelect.format,
                    type: pricingSelect.type,
                    price: pricingSelect.price
                } : null
            })
        })
            .then(() => {
                setIsSend(true)
            })
    }

    return (
        <div className={styles.admission}>
            <div className={styles.container}>
                
                {/* Header */}
                <div className={styles.header}>
                    <h2 className={styles.title}>Заявка на обучение</h2>
                    <p className={styles.subtitle}>
                        {course?.courseData ? (
                            <>
                                <span className={styles.courseName}>{course.courseData.title}</span>
                                <br />
                                {course.courseData.duration} · {course.courseData.frequency}
                                {course.courseData.level && (
                                    <>
                                        <br />
                                        <span className={styles.highlight}>{course.courseData.level}</span>
                                    </>
                                )}
                                {course.pricingOption ? (
                                    <>
                                        <br />
                                        <span className={styles.highlight}>
                                            {course.pricingOption.format === 'online' ? 'Онлайн' : 'Оффлайн'} · 
                                            {course.pricingOption.type === 'individual' ? 'Индивидуально' :
                                             course.pricingOption.type === 'closed_group' ? 'Закрытая группа' : 'Группа'}
                                        </span>
                                    </>
                                ) : course.courseData.specialOffer ? (
                                    <>
                                        <br />
                                        <span className={styles.highlight}>Специальное предложение</span>
                                        <br />
                                        <span className={styles.price}>{course.courseData.specialOffer.monthlyPayment.toLocaleString()} ₽/мес</span>
                                    </>
                                ) : null}
                            </>
                        ) : pricingSelect ? (
                            <>
                                Курс: <span className={styles.courseName}>{course?.name}</span>
                                <br />
                                Формат: <span className={styles.highlight}>{pricingSelect.format === 'online' ? 'Онлайн' : 'Оффлайн'}</span> · 
                                <span className={styles.highlight}>
                                    {pricingSelect.type === 'individual' ? 'Индивидуально' :
                                     pricingSelect.type === 'closed_group' ? 'Закрытая группа' : 'Группа'}
                                </span>
                            </>
                        ) : (
                            <>
                                Курс: <span className={styles.courseName}>{course?.name}</span>
                                <br />
                                Формат: <span className={styles.highlight}>{training[train_id.id]}</span>
                            </>
                        )}
                    </p>
                </div>

                {/* Pricing Details iOS Style */}
                {pricingDetails && (() => {
                    const isSimplePricing = course?.courseData?.id === 'bootcamp' || course?.courseData?.id === 'computer-literacy';
                    
                    return (
                        <div className={styles.pricingSection}>
                            <div className={styles.iosCard}>
                                <div className={styles.iosRow}>
                                    <span className={styles.iosLabel}>{isSimplePricing ? 'Стоимость' : 'Оплата в месяц'}</span>
                                    <span className={styles.iosValueMain}>{(course?.pricingOption?.price || pricingSelect?.price)?.toLocaleString()} ₽</span>
                                </div>
                                
                                {!isSimplePricing && (
                                    <>
                                        <div className={styles.iosDivider}></div>
                                        
                                        <div className={styles.iosRow}>
                                            <div className={styles.iosRowLeft}>
                                                <span className={styles.iosLabel}>Общая сумма</span>
                                                <span className={styles.iosSubtext}>за {pricingDetails.months} {pricingDetails.months === 1 ? 'месяц' : pricingDetails.months < 5 ? 'месяца' : 'месяцев'}</span>
                                            </div>
                                            <span className={styles.iosValueSmall}>{pricingDetails.totalMonthly.toLocaleString()} ₽</span>
                                        </div>
                                        
                                        <div className={styles.iosDivider}></div>
                                        
                                        <div className={styles.iosRowHighlight}>
                                            <div className={styles.iosRowLeft}>
                                                <span className={styles.iosLabelBold}>При полной оплате</span>
                                                <span className={styles.iosSubtextGreen}>экономия {pricingDetails.discount.toLocaleString()} ₽</span>
                                            </div>
                                            <span className={styles.iosValueGreen}>{pricingDetails.totalUpfront.toLocaleString()} ₽</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })()}

                {/* Content */}
                {!isSend ? (
                    <>
                        <form
                            className={styles.form}
                            onSubmit={(event) => {
                                event.preventDefault()
                                sendForm()
                            }}
                            noValidate
                        >
                            <div className={styles.formCard}>
                                <div className={`${styles.formRow} ${nameMsg ? styles.formRowError : ''}`}>
                                    <label
                                        htmlFor="admission-name"
                                        className={`${styles.formLabel} ${nameMsg ? styles.formLabelError : ''}`}
                                    >
                                        Имя
                                    </label>
                                    <input
                                        id="admission-name"
                                        type="text"
                                        name="name"
                                        autoComplete="given-name"
                                        enterKeyHint="next"
                                        value={name.val}
                                        onChange={onName}
                                        className={styles.formInput}
                                        placeholder="Как к вам обращаться"
                                        aria-invalid={Boolean(nameMsg)}
                                    />
                                </div>
                                <div className={styles.formDivider} aria-hidden />
                                <div className={`${styles.formRow} ${phoneMsg ? styles.formRowError : ''}`}>
                                    <label
                                        htmlFor="admission-phone"
                                        className={`${styles.formLabel} ${phoneMsg ? styles.formLabelError : ''}`}
                                    >
                                        Телефон
                                    </label>
                                    <input
                                        id="admission-phone"
                                        type="tel"
                                        name="phone"
                                        inputMode="tel"
                                        autoComplete="tel"
                                        enterKeyHint="send"
                                        value={phone.val}
                                        onFocus={onPhone}
                                        onChange={onPhone}
                                        className={styles.formInput}
                                        placeholder="+7 (900) 123 45 67"
                                        aria-invalid={Boolean(phoneMsg)}
                                    />
                                </div>
                            </div>

                            <LegalFormDisclaimer
                                variant="light"
                                consentChecked={consentAccepted}
                                onConsentChange={setConsentAccepted}
                            />

                            <button
                                type="submit"
                                className={styles.submitButton}
                                disabled={!canSubmit}
                            >
                                Отправить заявку
                            </button>
                        </form>
                        {showValidationToast && toastKey ? (
                            <div className={styles.formToast} role="alert" aria-live="assertive">
                                {toastKey}
                            </div>
                        ) : null}
                    </>
                ) : (
                    <div className={styles.successState}>
                        <div className={styles.successIcon}>
                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                <circle cx="32" cy="32" r="32" fill="#10B981"/>
                                <path d="M20 32L28 40L44 24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h3 className={styles.successTitle}>Заявка отправлена!</h3>
                        <p className={styles.successMessage}>
                            Спасибо за ваш интерес к нашим курсам. Мы свяжемся с вами в ближайшее время для уточнения деталей.
                        </p>
                        <button
                            type="button"
                            onClick={sendForm}
                            className={styles.closeButton}
                        >
                            Закрыть
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
